export enum MeasurementSystemEnum {
  imperial = "imperial",
  metric = "metric",
}

export const measurementSystemEnumTitleMap: Record<
  MeasurementSystemEnum,
  string
> = {
  [MeasurementSystemEnum.imperial]: "Imperial",
  [MeasurementSystemEnum.metric]: "Metric",
};
